import React, { useState, useEffect } from 'react';
import { Table, Button, Row, Col, message } from 'antd';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { connect } from 'react-redux';
import { addBuzz, resetAddBuzz } from 'appRedux/actions/Buzz';
import { fetchCategory } from 'appRedux/actions/Category';
import { fetchIndustry } from 'appRedux/actions/Industry';
import Widget from 'components/Widget';
import convertData from 'firebase/utils/convertData';
import { EditableCell, EditableFormRow } from './EditableCell';
import Columns from './Columns';

const InsertBuzz = ({ addBuzz, resetAddBuzz, fetchCategory, fetchIndustry, updating, payload, currentUser, categoryList, industryList, loadingIndustry, loadingCategory }) => {
  const [dataSource, setDataSource] = useState([
    {
      key: 0,
      brand: '',
      industry: '',
      category: '',
      value: '',
    }
  ]);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [count, setCount] = useState(1);
  const [isReset, setIsReset] = useState(false);
  const industries = isEmpty(industryList) ? [] : convertData(industryList);
  const categories = isEmpty(categoryList) ? [] : convertData(categoryList);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const isNotAllowSubmit = disableSubmit || dataSource.length === 0;

  const handleDelete = key => {
    const data = [...dataSource];
    setDataSource(data.filter(item => item.key !== key));
  };

  const columns = Columns(handleDelete).map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRow,
        handleError: handleError,
        isEditable: true,
        categories,
        industries,
        loadingIndustry: loadingIndustry,
        loadingCategory: loadingCategory,
        isReset: isReset,
      }),
    };
  });

  const handleReset = (e) => {
    e.preventDefault();
    setDisableSubmit(true);
    setCount(1);
    setIsReset(true);
    setDataSource([]);
  };

  const handleAdd = (e) => {
    e.preventDefault();
    const newData = {
      key: count,
      brand: '',
      industry: '',
      category: '',
      value: '',
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleUpdateRow = row => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const handleSave = (e) => {
    e.preventDefault();
    const validData = dataSource.filter(item => item.brand && item.value);
    if (validData.length === 0) {
      message.error({ content: 'Dữ liệu bạn nhập chưa đầy đủ thông tin', key: 'updatable', duration: 2 });
      return;
    }

    const params = validData.map((item, i) => ({
      index: i + 1,
      brand: item.brand,
      industry: item.industry,
      category: item.category,
      value: item.value * 1,
      created_by: currentUser,
      updated_by: currentUser,
      created_at: moment().unix(),
      updated_at: moment().unix(),
      isNotExact: true,
    }));
    addBuzz({ params });
  };

  const handleError = (isDisabled) => {
    setDisableSubmit(isDisabled);
  };

  useEffect(() => {
    if (payload.message) {
      if (payload.code === 200) {
        message.success({ content: payload.message, key: 'updatable', duration: 2 });
      } else {
        message.error({ content: payload.message, key: 'updatable', duration: 2 });
      }
      resetAddBuzz();
    }
  }, [payload.code, payload.message, resetAddBuzz]);

  useEffect(() => {
    fetchIndustry();
    fetchCategory();
  }, [fetchCategory, fetchIndustry]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Thêm dữ liệu brand</h2>}
          >
            <Button icon='plus' onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
              Thêm brand
            </Button>
            <Table
              className='gx-table-no-bordered'
              pagination={false}
              bordered={false}
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={dataSource}
              columns={columns}
            />
            <div className='save-segment'>
              <Button disabled={isNotAllowSubmit} loading={updating} onClick={handleSave} icon='vertical-align-bottom' size='large' type="primary">
                Save
              </Button>
              <Button disabled={updating} onClick={handleReset} icon='undo' size='large'>
                Reset
              </Button>
            </div>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ buzz, auth, industry, category }) => {
  const { updating, payload } = buzz;
  const { currentUser } = auth;
  const { data: categoryList, loading: loadingCategory } = category;
  const { data: industryList, loading: loadingIndustry } = industry;
  return { updating, payload, currentUser, categoryList, industryList, loadingCategory, loadingIndustry };
};

export default connect(
  mapStateToProps,
  { addBuzz, resetAddBuzz, fetchCategory, fetchIndustry }
)(InsertBuzz);
